if (!customElements.get('nordsign-drop-config')) {
  customElements.define('nordsign-drop-config', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('[data-drop-controls]').hidden = false;
      this.addEventListener('change', () => this.updateSelection());
      this.updateSelection();
    }

    updateSelection() {
      const size = this.querySelector('.ns-drop__sizes input:checked').value;
      const selectedPackage = this.querySelector('.ns-drop__package input:checked');
      const packageType = selectedPackage.value;
      this.querySelectorAll('[data-drop-size]').forEach(panel => {
        panel.hidden = panel.dataset.dropSize !== size;
        panel.querySelector('[data-set-copy]').hidden = packageType !== 'Complete set';
        panel.querySelector('[data-print-copy]').hidden = packageType === 'Complete set';
      });
      const quote = this.querySelector('[data-drop-quote]');
      const url = new URL(quote.href, window.location.origin);
      if (this.dataset.rootUrl) url.pathname = `${this.dataset.rootUrl.replace(/\/$/, '')}/pages/contact`;
      const sizeLabel = this.querySelector('.ns-drop__sizes legend').textContent.trim();
      const packageLabel = selectedPackage.closest('label').textContent.trim();
      url.searchParams.delete('product');
      url.hash = new URLSearchParams({ product: (`${this.dataset.productLabel || this.dataset.product} - ${sizeLabel} ${size} - ${packageLabel}`).trim() }).toString();
      quote.href = url.href;
      this.closest('.nordsign-product-page')?.querySelectorAll('[data-drop-page-quote]').forEach(link => { link.href = url.href; });
    }
  });
}
